module.exports = __webpack_public_path__ + "img/colaborador(2).40e37ef6.jpeg";